import * as angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { ConfigService } from "@common/service/config.service";
import { PopUpService } from "@common/popup/popup.service";

export interface IExtModuleService {
    initializeAnalyticsMod(): ng.IPromise<void>;
}

export class ExtModuleService implements IExtModuleService {
    static $inject = [
        "CacheService",
        "ApiAdapterService",
        "ConfigService",
        "$q",
        "PopUpService",
    ];

    constructor(
        private CacheService: CacheService,
        private $_api: JavaApiAdapterService,
        private ConfigService: ConfigService,
        private $q: ng.IQService,
        private PopUpService: PopUpService
    ) {}

    initializeAnalyticsMod = (): ng.IPromise<void> => {
        try {
            this.ConfigService.init();

            delete window["credentials"];

            if (!!window["pswd"]) {
                this.CacheService.setPassword(window["pswd"]);
            }
            return this.$q.when();
        } catch (e) {
            console.error("Failed to initialize analytics module", e);
            return this.$q.reject(e);
        }
    };
}

angular.module("eCareVault.common.services").service("ExtModuleService", ExtModuleService);
